import { DEFAULT_REMESH_SETTINGS } from '../constants'

export const initialRemeshSettingsState = {
  remeshSettings: { ...DEFAULT_REMESH_SETTINGS },
}
